import axios from "axios"
const url =require ('./url')


const baseUrl = url.database+'f1/'

//const baseUrl = 'http://esme.cuquicalvano.com:4000/cursos/'
//const  baseUrl ='http://localhost:4000/cursos/'



const loggedUserJSON = window.localStorage.getItem('loggedNoteAppUser')
/////loggedUserJSON Recupera lasesion el tokeny lo envia mediante la constante config. el back lo filtra 
 let config = ''

 if (loggedUserJSON) {

  try {
      const userContext = JSON.parse(loggedUserJSON)
      config = {
         headers:{
             Authorization:`Bearer ${userContext.token}`
         }
     }
  } catch (error) {
        window.localStorage.removeItem('loggedNoteAppUser')
   
  }
 

  
}else{
   config = {
      headers:{
          Authorization:`Bearer `
      }
  }
}



const traercanchas = async () => {
  
  // const data = await axios.post('http://localhost:4000/signupp', datos)
    const {data} = await axios.get(baseUrl+'traercanchas/', config)
  

return data
}

const traerJugadores = async (id) => {
  
  // const data = await axios.post('http://localhost:4000/signupp', datos)
    const {data} = await axios.post(baseUrl+'traerJugadores/', config)
  

return data
}

const traerligas = async (id) => {
  
  // const data = await axios.post('http://localhost:4000/signupp', datos)
    const {data} = await axios.get(baseUrl+'traerligas/', config)
  

return data
}



const traerpartidos = async (datos) => {
  
  // const data = await axios.post('http://localhost:4000/signupp', datos)
    const {data} = await axios.post(baseUrl+'traerpartidos/', datos, config)
  

return data
}



const responderconvocatoriadirecta = async (datos) => {
  
  // const data = await axios.post('http://localhost:4000/signupp', datos)
    const {data} = await axios.post(baseUrl+'responderconvocatoriadirecta/', datos, config)
  

return data
}
const traernotificaciones = async (formdata) => {
  const { data } = await axios.post(baseUrl + 'traernotificaciones', {id:formdata}, config)
  return data

}
const traersolicitudes = async (formdata) => {
  const { data } = await axios.post(baseUrl + 'traersolicitudes', formdata, config)
  return data

}

const crearpartido = async (formdata) => {
  console.log(formdata)
  const { data } = await axios.post(baseUrl + 'crearpartido', formdata, config)
  return data

}


const sumarsepartido = async (formdata) => {
  console.log(formdata)
  const { data } = await axios.post(baseUrl + 'sumarsepartido', formdata, config)
  return data

}


const confirmar = async (formdata) => {
  console.log(formdata)
  const { data } = await axios.post(baseUrl + 'confirmar', formdata, config)
  return data

}

const rechazar = async (formdata) => {
  console.log(formdata)
  const { data } = await axios.post(baseUrl + 'rechazar', formdata, config)
  return data

}


const marcarPendiente = async (formdata) => {
 
  const { data } = await axios.post(baseUrl + 'marcarPendiente', formdata, config)
  return data

}


const traerJugador = async (formdata) => {
  console.log(formdata)
  const { data } = await axios.post(baseUrl + 'traerJugador', formdata, config)
  return data

}


const modificarJugador = async (formdata) => {
  console.log(formdata)
  const { data } = await axios.post(baseUrl + 'modificarJugador', formdata, config)
  return data

}

const enviarConvocatoria = async (formdata) => {
  console.log(formdata)
  const { data } = await axios.post(baseUrl + 'enviarConvocatoria', formdata, config)
  return data

}


const convocarajugador = async (formdata) => {
  console.log(formdata)
  const { data } = await axios.post(baseUrl + 'convocarajugador', formdata, config)
  return data

}

const convocarajugadordirecto = async (formdata) => {
  console.log(formdata)
  const { data } = await axios.post(baseUrl + 'convocarajugadordirecto', formdata, config)
  return data

}

const cancelarConvocatoriaDirecta = async (formdata) => {
  console.log(formdata)
  const { data } = await axios.post(baseUrl + 'cancelarconvocatoria', formdata, config)
  return data

}

export default {responderconvocatoriadirecta,convocarajugadordirecto, cancelarConvocatoriaDirecta, traerligas,convocarajugador, enviarConvocatoria, traercanchas, crearpartido, traerpartidos, sumarsepartido, traernotificaciones, traersolicitudes, rechazar, confirmar,marcarPendiente, traerJugadores, traerJugador, modificarJugador}
